<template lang="en">
  <link rel="stylesheet" href="../CSS/App.css">
  <title>Home</title>
  <div>
    <div class="gradient-bg"></div>
    <div class="header">
      <Fade :appear="show" :transition-enter-duration="1200">
        <div class="home-header-flex">
          <div class="home-header-left">
            <hr1 :data-column="'hr1'">{{ BranchPage.hr1 }}</hr1>
            <div class="double_buttons">
              <div class="buy">
                <a role="button" @click="sendTo('/loan-officers')">
                  <KButton :data-column="'button1'" :size="null" :class="'custom-size3'" :theme-color="'null'"
                    :rounded="'large'">
                    <span style="font-weight: bold">{{ BranchPage.button1 }}</span>
                  </KButton>
                </a>
              </div>
              <div class="refinance">
                <a role="button" @click="sendTo('/find-loan/CashOut')">
                  <KButton :data-column="'button2'" :size="null" :class="'custom-size3'" :theme-color="'null'"
                    :rounded="'large'">
                    <span style="font-weight: bold">Tap Into Your Home Equity</span>
                  </KButton>
                </a>
              </div>
              <div class="refinance">
                <a role="button" @click="sendTo('/find-loan/refinance')">
                  <KButton :data-column="'button2'" :size="null" :class="'custom-size3'" :theme-color="'null'"
                    :rounded="'large'">
                    <span style="font-weight: bold">{{ BranchPage.button2 }}</span>
                  </KButton>
                </a>
              </div>
            </div>
          </div>
          <img alt="White background for the header." class="home-header-img"
            src="https://p23.zdusercontent.com/attachment/130390/2wVW259L2ErjyM7e5e1XL4ceB?...">
        </div>
      </Fade>
    </div>
    <div class="p1 first-par">
      <Fade :appear="show" :transition-enter-duration="1200">
        <div class="baby-photo"><img :data-column="'img2'" alt="Image of laughing baby." :src="BranchPage.img2"></div>
      </Fade>
      <div class="side-info">
        <div class="star"><img src="../assets/star.png"></div>
        <div class="h1 leading">
          <Zoom :appear="show" :transition-enter-duration="1200">
            <hr2 style="font-family: 'Montserrat', sans-serif; font-size: 2rem; font-weight: bolder;"
              :data-column="'hr2'">{{ BranchPage.hr2 }}</hr2>
          </Zoom>
        </div>
        <div class="para1">
          <Push :appear="'show'" :transition-enter-duration="1200">
            <p :data-column="p1" v-html="BranchPage.p1"></p>
          </Push>
          <Push :appear="show" :transition-enter-duration="1200">
            <div class="explore">
              <a role="button" @click="sendTo('/find-loan')">
                <KButton :data-column="'button3'" :size="null" :class="'custom-size3'" :theme-color="'null'"
                  :rounded="'large'">
                  {{ BranchPage.button3 }}
                </KButton>
              </a>
            </div>
          </Push>
        </div>
      </div>
    </div>
    <div class="info2">
      <div class="filled-star1"><img alt="Image within a star" style="width: 100%" :data-column="'star1'"
          :src="BranchPage.star1"></div>
      <div class="center-info1">
        <div class="h1 leading2">
          <hr2 :data-column="'hr3'">{{ BranchPage.hr3 }}</hr2>
        </div>
        <div class="para2">
            <p :data-column="p2" v-html="BranchPage.p2"></p>
        </div>
        <div class="button-line">
          <div class="gold-line"></div>
          <div class="driven">
            <a role="button" @click="sendTo('/process')">
              <KButton :data-column="'button4'" :size="null" :class="'custom-size3'" :theme-color="'null'"
                :rounded="'large'">
                {{ BranchPage.button4 }}
              </KButton>
            </a>
          </div>
          <div class="gold-line"></div>
        </div>
      </div>
      <div class="filled-star2"><img alt="Image within a star" style="width: 100%" :data-column="'star2'"
          :src="BranchPage.star2"></div>
    </div>
    <div class="info3">
      <div class="left-info">
        <div class="h1 leading3">
          <hr2 :data-column="'hr4'">{{ BranchPage.hr4 }}</hr2>
        </div>
        <div class="p1 para3">
          <p :data-column="'p3'" v-html="BranchPage.p3"></p>
        </div>
        <div class="find-loan-button">
          <a role="button" @click="sendTo('/loan-officers')">
            <KButton :data-column="'button5'" :size="null" :class="'custom-size3'" :theme-color="'null'"
              :rounded="'large'">
              {{ BranchPage.button5 }}
            </KButton>
          </a>
        </div>
      </div>
      <div class="dog-box"><img alt="Image of family with a dog." :data-column="'img3'" :src="BranchPage.img3"></div>
    </div>
    <div class="cards">
      <div class="cards-fr" :type="'info'">
        <div class="card1">
          <card :class="'custom-card'" style="width: 400px; border-radius: 5%; background-color: white; border-color: #f2b533; max-width: 95vw;">
            <cardImage :data-column="'cardimg1'" alt="img within the cards" :src="BranchPage.cardimg1"></cardImage>
            <cardBody>
              <cardTitle role="heading" :data-column="'cardhr1'">{{ BranchPage.cardhr1 }}</cardTitle>
              <p :data-column="'cardp1'">{{ BranchPage.cardp1 }}</p>
            </cardBody>
            <cardActions>
              <div :data-column="'cardbutton1'" class="card-button 1">
                <a role="button" @click="sendToAnchor('/about', '#OurStory')">
                  <KButton style="border-radius: 20px" :size="null" :class="'custom-size3'" :theme-color="'null'"
                  :style="'font-size: 1.1em'">{{ BranchPage.cardbutton1 }}</KButton>
                </a>
              </div>
            </cardActions>
          </card>
        </div>
        <div class="card3">
          <card style="width: 400px; border-radius: 5%; background-color: white; border-color: #f2b533; max-width: 95vw;">
            <cardImage :data-column="'cardimg3'" alt="img within the cards" :src="BranchPage.cardimg3"></cardImage>
            <cardBody>
              <cardTitle role="heading" :data-column="'cardhr3'">{{ BranchPage.cardhr3 }}</cardTitle>
              <p :data-column="'cardp3'">{{ BranchPage.cardp3 }}</p>
            </cardBody>
            <cardActions>
              <div class="card-button 3">
                <a role="button" @click="sendToAnchor('/about', '#Awards')">
                  <KButton style="border-radius: 20px" :data-column="'cardbutton3'" :size="null" :class="'custom-size3'"
                  :theme-color="'null'" :style="'font-size: 1.1em'">{{ BranchPage.cardbutton3 }}</KButton>
                </a>
              </div>
            </cardActions>
          </card>
        </div>
        <div class="card2">
          <card style="width: 400px; border-radius: 5%; background-color: white; border-color: #f2b533; max-width: 95vw;">
            <cardImage :data-column="'cardimg2'" alt="img within the cards" :src="BranchPage.cardimg2"></cardImage>
            <cardBody>
              <cardTitle role="heading" :data-column="'cardhr2'">{{ BranchPage.cardhr2 }}</cardTitle>
              <p :data-column="'cardp2'">{{ BranchPage.cardp2 }}</p>
            </cardBody>
            <cardActions>
              <div class="card-button 2">
                <a role="button" @click="sendTo('/find-loan')">
                  <KButton style="border-radius: 20px" :data-column="'cardbutton2'" :size="null" :class="'custom-size3'"
                  :theme-color="'null'" :style="'font-size: 1.1em'">{{ BranchPage.cardbutton2 }}</KButton>
                </a>
              </div>
            </cardActions>
          </card>
        </div>
      </div>
    </div>
    <div class="info4">
      <div class="left-info2">
        <div class="h1 leading5">
          <h2 style="font-size: 1.2em" :code-column="'hr6'">{{ BranchPage.hr6 }}</h2>
        </div>
        <div class="p1 para5">
          <p style="font-size: 19px" :data-column="'p5'" v-html="BranchPage.p5"></p>
        </div>
        <div class="driven">
          <a role="button" @click="sendTo('/loan-officers')">
            <KButton :data-column="'button6'" :size="null" :class="'custom-size3'" :theme-color="'null'"
            :rounded="'large'">{{ BranchPage.button6 }}</KButton>
          </a>
        </div>
      </div>
      <div class="review-card" style="width: 45%">
        <card style="width: 500px; height: 300px;">
          <cardBody style="margin-top: 10px; margin-left: 30px">
            <cardImage alt="Image of 5 stars for the review" :src="'https://uploads-ssl.webflow.com/62d16d4bfd1774e5fdff161d/63194eb8c3b0a00e62a9a3f4_goldstar-5-stars.png'" style="width: 35%"></cardImage>
            <cardTitle role="heading" :data-column="'cardhr4'">{{ BranchPage.cardhr4 }}</cardTitle>
            <p :data-column="'cardfooter'">{{ BranchPage.cardp4 }}</p>
            <p :data-column="'cardfooter'" v-html="BranchPage.cardfooter"></p>
          </cardBody>
        </card>
      </div>
    </div>
    <div class="end-page">
      <div class='show_bg'>
        <h2 style="font-size: 3.4em; margin-top: 100px; margin-left: 90px;" :data-column="'imagehr'">
          {{ BranchPage.imagehr }}</h2>
      </div>
    </div>
    <div class="blue-chunk"></div>
    <FooterComp></FooterComp>
  </div>
</template>

<script>

import FooterComp from "../components/Footer_Comp.vue"
import { Card, CardBody, CardImage, CardActions, CardTitle } from "@progress/kendo-vue-layout";
import '@progress/kendo-theme-default/dist/all.css';
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { Fade, Slide, Push, Zoom } from '@progress/kendo-vue-animation';
import apiService from '/src/api/api.service';

export default {
  name: "Home-Page",
  components: {
    FooterComp,
    'Zoom': Zoom,
    'Push': Push,
    'Fade': Fade,
    'Slide': Slide,
    card: Card,
    cardBody: CardBody,
    cardImage: CardImage,
    cardActions: CardActions,
    cardTitle: CardTitle,
    KButton,
  },


  data: function () {
    const searchParams = new URLSearchParams(window.location.search)
    var orgid = 'HQ';
    if (searchParams.has('org')) {
      orgid = searchParams.get('org');
    }

    return {
      show: true,
      orgid: orgid,
      BranchPage: {},
      isLoading: false,
      isVisible: false,
    };
  },

  mounted() {
    this.GetBranchPage();
    
  },
  methods: {
    GetBranchPage() {
      return apiService.GetBranchPage(this.orgid)
        .then(res => {
          this.BranchPage = res.data.data[0];
          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          console.log(error)
        });
    },
    sendTo(url) {
      const searchParams = new URLSearchParams(window.location.search)
      if (searchParams.has('org')) {
        window.location.href = url + '/?org=' + searchParams.get('org');
      }
      else
        window.location.href = url;
    },
    sendToAnchor(url1, url2) {
      const searchParams = new URLSearchParams(window.location.search)
      if (searchParams.has('org')) {
        window.location.href = url1 + '/?org=' + searchParams.get('org') + url2;
      }
      else
        window.location.href = url1 + url2;
    }
  }
};
</script>

<style>
@import '/src/assets/css/homeView.css';
</style>